import { useEffect } from "react";

/**
 * Tawk.to live chat loader.
 * Mounts the official Tawk embed script when both env vars are set:
 *   - REACT_APP_TAWK_PROPERTY_ID
 *   - REACT_APP_TAWK_WIDGET_ID
 * Returns null when either is missing so the caller can fall back to the
 * built-in chat widget.
 */
export default function TawkChat() {
  const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
  const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID;
  const enabled = Boolean(propertyId && widgetId);

  useEffect(() => {
    if (!enabled) return;
    if (window.Tawk_API && document.getElementById("tawk-script")) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    s1.id = "tawk-script";
    s1.async = true;
    s1.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s1.setAttribute("data-testid", "tawk-script");
    document.body.appendChild(s1);

    return () => {
      // We intentionally do NOT remove the script on unmount — Tawk handles
      // its own DOM lifecycle and re-mounting causes flicker.
    };
  }, [enabled, propertyId, widgetId]);

  return null;
}

export const TAWK_ENABLED = Boolean(
  process.env.REACT_APP_TAWK_PROPERTY_ID && process.env.REACT_APP_TAWK_WIDGET_ID
);
